class BulkProcessingModule {
  constructor(
    options = {
      id: null,
      menuOptionTitle: 'Bulk Update',
      component: null,
    }
  ) {
    this.id = options.id
    this.menuOptionTitle = options.menuOptionTitle
    this.component = options.component
  }

  set id(id) {
    this._id = id
  }

  get id() {
    return this._id
  }

  set menuOptionTitle(s) {
    this._menuOptionTitle = s
  }

  get menuOptionTitle() {
    return this._menuOptionTitle
  }

  set component(component) {
    this._component = component
  }

  get component() {
    return this._component
  }
}

export default BulkProcessingModule
